<div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
    <h4 class="matDialogTitle" mat-dialog-title [textContent]="data.title"></h4>
    <span class="material-icons mb-1" mat-dialog-close>close</span>
</div>
<mat-dialog-content class="mat-typography">
    <material-input [autofocus]="false" [name]="'filterName'" [id]="'filterName'" [title]="translateMsg('Name your view filter')" [model]="filterName" [required]="true" [placeholder]="translateMsg('Name your view filter')" (modelChange)="onModelChange($event)"></material-input>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <material-button mat-dialog-close class="mx-2 noOutline" [text]="translateMsg('Cancel')"></material-button>
    <material-button [color]="'primary'" [text]="translateMsg('Save & Search')" (buttonClicked)="saveFilter()" [disabled]="!newFilterName"></material-button>
</mat-dialog-actions>
